var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "paycools-kyc-page" },
    [
      _c("aside", { staticClass: "kyc-sidebar" }, [
        _c(
          "ul",
          { staticClass: "kyc-step-list" },
          _vm._l(_vm.steps, function (step, index) {
            return _c(
              "li",
              {
                key: step.value,
                staticClass: "kyc-step-item",
                class: {
                  "is-active": _vm.activeStep === index,
                  "is-disabled": _vm.isStepDisabled(index),
                },
                on: {
                  click: function ($event) {
                    return _vm.handleStepClick(index)
                  },
                },
              },
              [
                _c("span", { staticClass: "kyc-step-index" }, [
                  _vm._v(_vm._s(index + 1) + "."),
                ]),
                _c("span", { staticClass: "kyc-step-label" }, [
                  _vm._v(_vm._s(step.label)),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _c(
        "section",
        { staticClass: "kyc-content" },
        [
          _c(
            "keep-alive",
            [
              _c(_vm.currentComponent, {
                ref: "stepComponent",
                tag: "component",
                attrs: {
                  "kyc-data": _vm.kycData,
                  "company-files": _vm.companyFiles,
                  loading: _vm.loading,
                  submitting: _vm.submitting,
                },
                on: {
                  next: _vm.handleNext,
                  submit: _vm.handleSubmit,
                  requestBack: _vm.onBack,
                  firstStepSaved: function ($event) {
                    _vm.firstStepSaved = true
                  },
                  saved: _vm.fetchKycData,
                  markChanged: _vm.markChanged,
                  resetChanged: _vm.resetChanged,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("kyc.exit_dialog_title"),
            visible: _vm.showExitDialog,
            width: "600px",
            "close-on-click-modal": false,
            "show-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showExitDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "font-size": "16px", color: "#243b55" } },
            [_vm._v(" " + _vm._s(_vm.$t("kyc.exit_with_unsaved")) + " ")]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              staticStyle: {
                display: "flex",
                gap: "16px",
                "justify-content": "flex-end",
              },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showExitDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("kyc.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveAllAndNavigateHome },
                },
                [_vm._v(_vm._s(_vm.$t("kyc.save")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }